import { Card } from '@fl/cmsch-fe-library';
import React, { FC, memo, useMemo } from 'react';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { RolesTable } from '../components/roles-table';
const RolesBase: FC = _ => {
  const {
    t
  } = useOurTranslation('admin');
  const title = t('roles');
  const header = useMemo(() => <ConnectedScreenHeader title={title} />, [title]);
  return <Content browserTabTitle={title} data-sentry-element="Content" data-sentry-component="RolesBase" data-sentry-source-file="roles.tsx">
            <Card title={header} titleSize="medium" noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="roles.tsx">
                <RolesTable data-sentry-element="RolesTable" data-sentry-source-file="roles.tsx" />
            </Card>
        </Content>;
};

/** Admin roles screen. */
export const Roles = memo(RolesBase);